import { Component } from 'react';
import { withRouter } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';

class ScrollToTopOnLocationChange extends Component {
  componentDidUpdate(prevProps) {
    // eslint-disable-next-line react/destructuring-assignment -- overkill for this simple use case
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

ScrollToTopOnLocationChange.propTypes = {
  location: PropTypes.shape({}).isRequired,
};

export default withRouter(ScrollToTopOnLocationChange);
